import React, { lazy } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
export const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const handleContinue = () => {
    // Navigate to the next step
    navigate('/onboarding/step2');
  };
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-516">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-517" />
      <div className="flex-1 flex flex-col items-center py-8 px-8 md:px-12" data-id="element-518">
        {/* Logo */}
        <div className="mb-6 w-48 md:w-60" data-id="element-519">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-520" />
        </div>
        {/* Headline */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-6 max-w-4xl" data-id="element-521">
          To Get Started: Please Dedicate Time To Watching The Video Below
        </h1>
        {/* Video note */}
        <p className="text-lg md:text-xl text-[#00c853] font-medium mb-4" data-id="element-522">
          Click Play & Watch At 1.5x Speed For Faster Efficiency
        </p>
        {/* Video Embed */}
        <div className="w-full max-w-4xl mb-8" data-id="element-523">
          <div className="aspect-video w-full bg-dark-700 rounded-xl overflow-hidden shadow-xl border-2 border-dark-500" data-id="element-524">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-525">
              <iframe src="https://iframe.mediadelivery.net/embed/460652/66a244ba-109b-4a54-89b0-d7b26027b567?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-526"></iframe>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="w-full max-w-2xl" data-id="element-527">
          <a href="https://calendly.com/customers-on-command/deal-flow-onboarding" target="_blank" rel="noopener noreferrer" className="block w-full py-7 px-10 bg-[#00c853] hover:bg-[#00a844] text-white text-xl sm:text-2xl md:text-3xl font-medium rounded-md shadow-lg shadow-[#00c853]/20 transition-all duration-200 animate-seesaw text-center" data-id="element-528">
            Schedule In My Onboarding Call &gt;&gt;
          </a>
        </div>
      </div>
    </div>;
};